import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { InviteCodeUI } from '~/components/screens/InviteCodeUI'
import { useBffWebOnboardingInviteCodeValidation } from '../utils'

const ERROR_MESSAGE =
  'Invite code not recognized. Please double-check the code in your enrollment info or ask your HR team for help.'

/**
 * Authenticated invite code validation screen.
 */
const AuthenticatedInviteCodeValidation: React.FC = () => {
  const history = useHistory()
  const inviteCodeValidation = useBffWebOnboardingInviteCodeValidation()
  const [error, setError] = useState<string | null>(null)

  // Sync error state: only display 400 validation errors in the form
  useEffect(() => {
    if (inviteCodeValidation.error) {
      const apiError = inviteCodeValidation.error as any

      if (apiError?.status === 400) {
        // Display validation errors from BFF in the form
        setError(ERROR_MESSAGE)
      } else {
        history.push({ pathname: '/error' })
      }
    }
  }, [inviteCodeValidation.error, history])

  const handleSubmit = async (inviteCode: string) => {
    setError(null)
    await inviteCodeValidation.handler(inviteCode)
  }

  return (
    <InviteCodeUI onSubmit={handleSubmit} error={error} isLoading={inviteCodeValidation.loading} />
  )
}

export default AuthenticatedInviteCodeValidation
